module.exports = __webpack_public_path__ + "img/1.8be3fd43.jpg";